import * as Yup from "yup";

export const enabledAppsValidation = Yup.object().shape({
  oneAppSelected: Yup.boolean()
});
